import { useState } from "react";
import { Play } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useGetNoteFile } from "../useGetNoteFile";
import { VideoPreview } from "./VideoPreview";

export const NoteVideo = observer(({ id }: Dryp.Note) => {
	const [isOpen, setIsOpen] = useState(false);
	const { fetchNoteFile, fileUrl, loading, mime } = useGetNoteFile(id);

	const handleClick = () => {
		setIsOpen(true);
		fetchNoteFile();
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	return (
		<>
			<div
				className="w-10 h-10 rounded overflow-hidden border border-border bg-secondary flex items-center justify-center cursor-pointer hover:bg-secondary/80"
				onClick={handleClick}
			>
				<Play className="w-4 h-4 text-muted-foreground" />
			</div>
			{isOpen && <VideoPreview videoSrc={fileUrl} mime={mime} loading={loading} onClose={handleClose} />}
		</>
	);
});
